import { createContext, useContext, useEffect, useState } from "react";

const RelativeTimeTickContext = createContext(0);

export function RelativeTimeTickProvider({ children, intervalMs = 15000 }) {
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return (
    <RelativeTimeTickContext.Provider value={tick}>
      {children}
    </RelativeTimeTickContext.Provider>
  );
}

/** Subscribe to the shared tick. Returns a counter that increments each interval. */
export function useRelativeTimeTick() {
  return useContext(RelativeTimeTickContext);
}
